import { useEffect, useState } from 'react';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import MemberForm from '../components/MemberForm';
import MessageModal from '../components/MessageModal';
import { getMemberById, updateMember, getMemberSkills } from '../services/api/memberService';

const EditMemberPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || '/members';

  const [selectedMember, setSelectedMember] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [language, setLanguage] = useState('ID');
  const [error, setError] = useState('');

  const t = (en, id) => (language === 'EN' ? en : id);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        console.log('Fetched user from localStorage:', user);
        if (!user) {
          navigate('/login');
          return;
        }

        // --- Ambil data member
        const member = await getMemberById(id);
        if (!member) {
          console.error('Member not found');
          navigate(from);
          return;
        }

        // --- Role check
        if (user.role_id !== 1 && user.role_id !== 2 && user.id !== member.id) {
          navigate('/unauthorized');
          return;
        }

        // --- Ambil skill member
        const { data: skillData, error: skillError } = await getMemberSkills(id);
        if (skillError) {
          console.warn('Error fetching member skills:', skillError.message);
        }

        const formattedSkills = (skillData || []).map((s) => ({
          id: s.skill_id,
          name: s.skills?.name || '',
        }));

       

        setSelectedMember({
          ...member,
          skills: formattedSkills,
        });
      } catch (err) {
        console.error('Failed to fetch member data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id, navigate]);

  if (loading) return <div>Loading...</div>;

  const handleSubmit = async (data, lang) => {
    setError('');
    setLanguage(lang);

    const result = await updateMember(id, data);

    if (!result.success) {
      setError(result.message);
    }

    setIsModalOpen(true); // ✅ modal muncul SETELAH global loading mati
  };

  const handleClose = () => {
    setIsModalOpen(false);
    if (error === '') navigate(from);
  };

  return (
    <div className="page-container">
      {selectedMember ? (
        <MemberForm
          key={selectedMember?.id || 'new-member'} // ✅ force re-render jika ID berubah
          isEdit={true}
          initialData={selectedMember}
          onSubmit={handleSubmit}
          onCancel={() => navigate(from)}
        />
      ) : (
        <p>Loading...</p>
      )}

      {isModalOpen && (
        <MessageModal 
          onClose={handleClose}
          title={error == '' ? t('Successfully Saved', 'Berhasil Disimpan') : t('Edit Failed', 'Gagal Mengedit')}
          message_content={error == '' ? t(
                      'Your data changes were successfully saved.', 'Perubahan data anda berhasil disimpan.'
                    ) : error}  
          icon={error == '' ? <FaCheckCircle/> : <FaTimesCircle/>}
          button_name={t('Close', 'Tutup')} 
          isSuccess={error == '' ? true : false} 
        />
      )}
    </div>
  );
};

export default EditMemberPage;
